/**
 * @group Components
 * @summary <blockquote>ThumbDownIcon icon component.</blockquote>
 * @example
 * ```tsx
 * <ThumbDownIcon />
 * ```
 */
export const ThumbDownIcon = ({ size = 16 }: { size?: number }) => (
        <svg
          height={size}
          strokeLinejoin="round"
          viewBox="0 0 16 16"
          width={size}
          style={{ color: 'currentcolor' }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.89531 13.7603C6.72984 13.8785 6.5 13.7602 6.5 13.5569V10.75C6.5 9.7835 5.7165 9 4.75 9H2.5V2.5H12.1884C12.762 2.5 13.262 2.89037 13.4011 3.44683L14.4011 7.44683C14.5984 8.23576 14.0017 9 13.1884 9H9.25H8.5V9.75V12.4854C8.5 12.5662 8.46101 12.6419 8.39531 12.6889L6.89531 13.7603ZM5 13.5569C5 14.9803 6.6089 15.8082 7.76717 14.9809L9.26717 13.9095C9.72706 13.581 10 13.0506 10 12.4854V10.5H13.1884C14.9775 10.5 16.2903 8.81868 15.8563 7.08303L14.8563 3.08303C14.5503 1.85882 13.4503 1 12.1884 1H1.75H1V1.75V9.75V10.5H1.75H4.75C4.88807 10.5 5 10.6119 5 10.75V13.5569Z"
            fill="currentColor"
          />
        </svg>
      );